export default __webpack_public_path__ + "static/media/person.58f5e989.jpg";